// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* --- Cisco-Inspired Enterprise Dark Mode --- */

.Modal_backdrop__Ovtnz {
    position: fixed;
    inset: 0;
    background: rgba(15, 20, 25, 0.85); /* Etwas dunklerer, neutralerer Backdrop */
    backdrop-filter: blur(4px);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
}

.Modal_modal__ZjBx1 {
    width: 100%;
    max-width: 750px;
    background: #1a1f26; /* Deep Enterprise Blue-Grey */
    color: #e1e5ea;
    border-radius: 4px; /* Weniger rund, eher funktional */
    border: 1px solid #323c47;
    box-shadow: 0 20px 50px rgba(0, 0, 0, 0.5);
    display: flex;
    flex-direction: column;
    overflow: hidden;
    animation: Modal_modalAppear__QBmPt 0.2s ease-out;
}

@keyframes Modal_modalAppear__QBmPt {
    from { opacity: 0; transform: translateY(10px); }
    to { opacity: 1; transform: translateY(0); }
}

/* Header: Fokus auf die IP */
.Modal_modalHeader__U9Vy- {
    background: #232931;
    padding: 1.25rem 2rem;
    border-bottom: 2px solid lightblue; /* Cisco Blue Accent Line */
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.Modal_headerTitle__4sHd5 .Modal_label__rTatD {
    font-size: 0.7rem;
    font-weight: 700;
    color: lightblue;
    text-transform: uppercase;
    letter-spacing: 1px;
}

.Modal_headerTitle__4sHd5 h2 {
    margin: 4px 0;
    font-family: 'Segoe UI', Roboto, Helvetica, sans-serif;
    font-size: 1.75rem;
    font-weight: 400;
    color: #ffffff;
}

.Modal_headerTitle__4sHd5 .Modal_subtext__T0hY6 {
    font-size: 0.85rem;
    color: #8a96a3;
    font-family: 'Roboto Mono', monospace;
}

.Modal_closeBtn__5dZp- {
    background: none;
    border: none;
    color: #8a96a3;
    font-size: 1.5rem;
    cursor: pointer;
    transition: color 0.2s;
}

.Modal_closeBtn__5dZp-:hover {
    color: #fff;
}

/* Body & Sections */
.Modal_bodyContainer__jsQwY {
    padding: 2rem;
    overflow-y: auto;
    max-height: 75vh;
    background: #1a1f26;
}

.Modal_section__TC5Or {
    margin-bottom: 2.5rem;
}

.Modal_sectionTitle__vFmlp {
    font-size: 0.85rem;
    text-transform: uppercase;
    color: #ffffff;
    border-bottom: 1px solid #323c47;
    padding-bottom: 8px;
    margin-bottom: 1.5rem;
    font-weight: 600;
    letter-spacing: 0.5px;
}

.Modal_grid__Ei5VB {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 12px 60px;
}

.Modal_infoRow__ZZQX8 {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 0;
    border-bottom: 1px solid #282f38;
}

.Modal_key__gHvEm {
    color: #8a96a3;
    font-size: 0.85rem;
}

.Modal_value__T9FA9 {
    color: #ffffff;
    font-weight: 400;
    font-size: 0.9rem;
}

.Modal_value__T9FA9 a {
    color: #ff5555;
    text-decoration: none;
}

.Modal_value__T9FA9 a:hover {
    text-decoration: underline;
}

/* Status Badges */
.Modal_badge__43M\\+M {
    padding: 3px 12px;
    border-radius: 12px; /* Pill-Shape für Status */
    font-size: 0.7rem;
    font-weight: 700;
    text-transform: uppercase;
}

.Modal_success__dJWop {
    background: rgba(45, 170, 117, 0.15);
    color: #4cd995;
    border: 1px solid rgba(45, 170, 117, 0.3);
}

.Modal_error__07rxZ {
    background: rgba(235, 87, 87, 0.15);
    color: #ff6b6b;
    border: 1px solid rgba(235, 87, 87, 0.3);
}

/* Score Badge (Heat-map) */
.Modal_scoreBadge__2RnVB {
    padding: 2px 8px;
    border-radius: 3px;
    font-weight: bold;
    font-size: 0.85rem;
}

.Modal_scoreHigh__TcQ6x { color: #ff6b6b; background: rgba(235, 87, 87, 0.1); }
.Modal_scoreMed__oI\\+jT { color: #f2c94c; background: rgba(242, 201, 76, 0.1); }
.Modal_scoreLow__mGLmC { color: #4cd995; background: rgba(76, 175, 80, 0.1); }

/* Ports Analysis */
.Modal_portContainer__jQ6cv {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
}

.Modal_portItem__DSYaX {
    display: flex;
    flex-direction: column;
    width: 70px;
    background: #232931;
    border: 1px solid #323c47;
    border-radius: 3px;
    transition: all 0.2s;
}

.Modal_portNumber__H-he5 {
    background: #2d353e;
    padding: 6px;
    font-size: 0.8rem;
    font-weight: bold;
    color: #e1e5ea;
}

.Modal_portStatus__kBNLa {
    padding: 4px;
    font-size: 0.65rem;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.Modal_portOpen__FdU-g {
    border: 2px solid #50fa7b;
    background: rgba(6, 122, 180, 0.05);
}

.Modal_portOpen__FdU-g .Modal_portStatus__kBNLa {
    border-color: #50fa7b;
    
}

.Modal_portClosed__kjldG {
    opacity: 0.5;
}

.Modal_flagIcon__XqBbO {
    width: 22px;
    height: auto;
    margin-right: 8px;
    border-radius: 1px;
    filter: saturate(0.8);
}`, "",{"version":3,"sources":["webpack://./src/components/Modal.module.css"],"names":[],"mappings":"AAAA,gDAAgD;;AAEhD;IACI,eAAe;IACf,QAAQ;IACR,kCAAkC,EAAE,0CAA0C;IAC9E,0BAA0B;IAC1B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,mBAAmB,EAAE,8BAA8B;IACnD,cAAc;IACd,kBAAkB,EAAE,kCAAkC;IACtD,yBAAyB;IACzB,0CAA0C;IAC1C,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,iDAAoC;AACxC;;AAEA;IACI,OAAO,UAAU,EAAE,2BAA2B,EAAE;IAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC/C;;AAEA,6BAA6B;AAC7B;IACI,mBAAmB;IACnB,qBAAqB;IACrB,kCAAkC,EAAE,2BAA2B;IAC/D,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sDAAsD;IACtD,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,qCAAqC;AACzC;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,iBAAiB;IACjB,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,WAAW;AACf;;AAEA,oBAAoB;AACpB;IACI,aAAa;IACb,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,cAAc;IACd,gCAAgC;IAChC,mBAAmB;IACnB,qBAAqB;IACrB,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,gCAAgC;AACpC;;AAEA;IACI,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA,kBAAkB;AAClB;IACI,iBAAiB;IACjB,mBAAmB,EAAE,0BAA0B;IAC/C,iBAAiB;IACjB,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;IACpC,cAAc;IACd,yCAAyC;AAC7C;;AAEA;IACI,mCAAmC;IACnC,cAAc;IACd,wCAAwC;AAC5C;;AAEA,2BAA2B;AAC3B;IACI,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA,0BAAa,cAAc,EAAE,kCAAkC,EAAE;AACjE,0BAAY,cAAc,EAAE,mCAAmC,EAAE;AACjE,yBAAY,cAAc,EAAE,kCAAkC,EAAE;;AAEhE,mBAAmB;AACnB;IACI,aAAa;IACb,eAAe;IACf,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,mCAAmC;AACvC;;AAEA;IACI,qBAAqB;;AAEzB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,qBAAqB;AACzB","sourcesContent":["/* --- Cisco-Inspired Enterprise Dark Mode --- */\n\n.backdrop {\n    position: fixed;\n    inset: 0;\n    background: rgba(15, 20, 25, 0.85); /* Etwas dunklerer, neutralerer Backdrop */\n    backdrop-filter: blur(4px);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 9999;\n}\n\n.modal {\n    width: 100%;\n    max-width: 750px;\n    background: #1a1f26; /* Deep Enterprise Blue-Grey */\n    color: #e1e5ea;\n    border-radius: 4px; /* Weniger rund, eher funktional */\n    border: 1px solid #323c47;\n    box-shadow: 0 20px 50px rgba(0, 0, 0, 0.5);\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n    animation: modalAppear 0.2s ease-out;\n}\n\n@keyframes modalAppear {\n    from { opacity: 0; transform: translateY(10px); }\n    to { opacity: 1; transform: translateY(0); }\n}\n\n/* Header: Fokus auf die IP */\n.modalHeader {\n    background: #232931;\n    padding: 1.25rem 2rem;\n    border-bottom: 2px solid lightblue; /* Cisco Blue Accent Line */\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.headerTitle .label {\n    font-size: 0.7rem;\n    font-weight: 700;\n    color: lightblue;\n    text-transform: uppercase;\n    letter-spacing: 1px;\n}\n\n.headerTitle h2 {\n    margin: 4px 0;\n    font-family: 'Segoe UI', Roboto, Helvetica, sans-serif;\n    font-size: 1.75rem;\n    font-weight: 400;\n    color: #ffffff;\n}\n\n.headerTitle .subtext {\n    font-size: 0.85rem;\n    color: #8a96a3;\n    font-family: 'Roboto Mono', monospace;\n}\n\n.closeBtn {\n    background: none;\n    border: none;\n    color: #8a96a3;\n    font-size: 1.5rem;\n    cursor: pointer;\n    transition: color 0.2s;\n}\n\n.closeBtn:hover {\n    color: #fff;\n}\n\n/* Body & Sections */\n.bodyContainer {\n    padding: 2rem;\n    overflow-y: auto;\n    max-height: 75vh;\n    background: #1a1f26;\n}\n\n.section {\n    margin-bottom: 2.5rem;\n}\n\n.sectionTitle {\n    font-size: 0.85rem;\n    text-transform: uppercase;\n    color: #ffffff;\n    border-bottom: 1px solid #323c47;\n    padding-bottom: 8px;\n    margin-bottom: 1.5rem;\n    font-weight: 600;\n    letter-spacing: 0.5px;\n}\n\n.grid {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    gap: 12px 60px;\n}\n\n.infoRow {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 10px 0;\n    border-bottom: 1px solid #282f38;\n}\n\n.key {\n    color: #8a96a3;\n    font-size: 0.85rem;\n}\n\n.value {\n    color: #ffffff;\n    font-weight: 400;\n    font-size: 0.9rem;\n}\n\n.value a {\n    color: #ff5555;\n    text-decoration: none;\n}\n\n.value a:hover {\n    text-decoration: underline;\n}\n\n/* Status Badges */\n.badge {\n    padding: 3px 12px;\n    border-radius: 12px; /* Pill-Shape für Status */\n    font-size: 0.7rem;\n    font-weight: 700;\n    text-transform: uppercase;\n}\n\n.success {\n    background: rgba(45, 170, 117, 0.15);\n    color: #4cd995;\n    border: 1px solid rgba(45, 170, 117, 0.3);\n}\n\n.error {\n    background: rgba(235, 87, 87, 0.15);\n    color: #ff6b6b;\n    border: 1px solid rgba(235, 87, 87, 0.3);\n}\n\n/* Score Badge (Heat-map) */\n.scoreBadge {\n    padding: 2px 8px;\n    border-radius: 3px;\n    font-weight: bold;\n    font-size: 0.85rem;\n}\n\n.scoreHigh { color: #ff6b6b; background: rgba(235, 87, 87, 0.1); }\n.scoreMed { color: #f2c94c; background: rgba(242, 201, 76, 0.1); }\n.scoreLow { color: #4cd995; background: rgba(76, 175, 80, 0.1); }\n\n/* Ports Analysis */\n.portContainer {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 8px;\n}\n\n.portItem {\n    display: flex;\n    flex-direction: column;\n    width: 70px;\n    background: #232931;\n    border: 1px solid #323c47;\n    border-radius: 3px;\n    transition: all 0.2s;\n}\n\n.portNumber {\n    background: #2d353e;\n    padding: 6px;\n    font-size: 0.8rem;\n    font-weight: bold;\n    color: #e1e5ea;\n}\n\n.portStatus {\n    padding: 4px;\n    font-size: 0.65rem;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n}\n\n.portOpen {\n    border: 2px solid #50fa7b;\n    background: rgba(6, 122, 180, 0.05);\n}\n\n.portOpen .portStatus {\n    border-color: #50fa7b;\n    \n}\n\n.portClosed {\n    opacity: 0.5;\n}\n\n.flagIcon {\n    width: 22px;\n    height: auto;\n    margin-right: 8px;\n    border-radius: 1px;\n    filter: saturate(0.8);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"backdrop": `Modal_backdrop__Ovtnz`,
	"modal": `Modal_modal__ZjBx1`,
	"modalAppear": `Modal_modalAppear__QBmPt`,
	"modalHeader": `Modal_modalHeader__U9Vy-`,
	"headerTitle": `Modal_headerTitle__4sHd5`,
	"label": `Modal_label__rTatD`,
	"subtext": `Modal_subtext__T0hY6`,
	"closeBtn": `Modal_closeBtn__5dZp-`,
	"bodyContainer": `Modal_bodyContainer__jsQwY`,
	"section": `Modal_section__TC5Or`,
	"sectionTitle": `Modal_sectionTitle__vFmlp`,
	"grid": `Modal_grid__Ei5VB`,
	"infoRow": `Modal_infoRow__ZZQX8`,
	"key": `Modal_key__gHvEm`,
	"value": `Modal_value__T9FA9`,
	"badge": `Modal_badge__43M+M`,
	"success": `Modal_success__dJWop`,
	"error": `Modal_error__07rxZ`,
	"scoreBadge": `Modal_scoreBadge__2RnVB`,
	"scoreHigh": `Modal_scoreHigh__TcQ6x`,
	"scoreMed": `Modal_scoreMed__oI+jT`,
	"scoreLow": `Modal_scoreLow__mGLmC`,
	"portContainer": `Modal_portContainer__jQ6cv`,
	"portItem": `Modal_portItem__DSYaX`,
	"portNumber": `Modal_portNumber__H-he5`,
	"portStatus": `Modal_portStatus__kBNLa`,
	"portOpen": `Modal_portOpen__FdU-g`,
	"portClosed": `Modal_portClosed__kjldG`,
	"flagIcon": `Modal_flagIcon__XqBbO`
};
export default ___CSS_LOADER_EXPORT___;
